






























import {Vue, Component} from 'vue-property-decorator'
import NetworkAnalytics from './network/Analytics.vue'
import ChannelAnalytics from './channels/Analytics.vue'

@Component({
  components: {
    NetworkAnalytics,
    ChannelAnalytics,
  },
})
class Dashboard extends Vue {}
export default Dashboard
